(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/forecast-payment.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/forecast-payment.js');
"use strict";

svs.game_results.views.ForecastPayment = Marionette.View.extend({
  template(data) {
    return svs.game_results.templates.forecast_payment(data);
  },
  className() {
    return this.model.get('forecast').cancelled ? '' : 'panel panel-default margin-xs-0';
  },
  modelEvents: {
    winresultUpdate: 'render'
  }
});

 })(window);